import styled from 'styled-components';

import Text from './Text';

/**
 * Represents a block level, styled text element.
 *
 * Use this element when you want to style the text and also need a block level element. If you need
 * to add whitespace around a block of text, extend this component using `styled(TextBlock)`.
 *
 * This is good for displaying user content because newlines will be preserved in the presentation.
 *
 * If you need to style some text within a sentence, or to have an inline text element for any other
 * reason, use Text instead.
 */
const TextBlock = styled(Text)`
  display: block;
  ${({ align }) => align && `text-align: ${align}`};
  white-space: pre-wrap;
`;

export default TextBlock;
